module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"#8b8b8b\" height=\"24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\">\n  <polygon points=\"1.9,16.2 3.6,17.9 12,9.5 20.4,17.9 22.1,16.2 12,6.1 12,6.1 12,6.1 \"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/arrow-up.svg
// module id = 779
// module chunks = 1